/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const DismissButtonTemplate = `
<div class="toast__dismiss">
    <sirius-icon shape="window-close" set="cds" size="24" aria-hidden="true"></sirius-icon>
</div>
`;
